import { render, staticRenderFns } from "./coupon-reg-modal.vue?vue&type=template&id=97039dc2&scoped=true&"
import script from "./coupon-reg-modal.vue?vue&type=script&lang=js&"
export * from "./coupon-reg-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97039dc2",
  null
  
)

export default component.exports